<template>
  <v-card outlined>
    <v-container>
      <v-toolbar flat dense>
        <div>{{$t("deliveryMethod.locations")}}</div>
      </v-toolbar>
      <v-autocomplete
        v-model="eligibilityConditions.locations"
        :items="allLocations"
        :item-text="item =>`${item.location_id} (${item.name})`"
        item-value="location_id"
        :label="$t('deliveryMethod.locations')"
        class="d-flex justify-center align-center py-2"
        dense
        multiple
        hide-details="auto"
        outlined
        clearable
      >
        <template v-slot:selection="{ item, index }">
          <v-chip small v-if="index === 0">
            <span v-if="index === 0">{{ item.location_id }}</span>
          </v-chip>
          <span
            v-if="index === 1"
            class="grey--text caption"
          >(+{{ eligibilityConditions.locations.length - 1 }} {{$t("deliveryMethod.others")}})</span>
        </template>
      </v-autocomplete>
    </v-container>
  </v-card>
</template>

<script>
  import { EventBus } from '@/event-bus'

  export default {
    name: "locationsEligibility",
    props: {
      eligibilityConditions: {
        type: Object,
        default: null,
      },
    },
    data() {
      return {
        allLocations: [],
        loading: false
      }
    },
    mounted() {
      this.listLocations()
    },
    computed: {
      isMobile () {
        return this.$vuetify.breakpoint.width <= 600
      },
    },
    methods: {
      listLocations() {
        this.loading = true
        let myInit = {
          headers: {
            Authorization: 'Bearer ' + this.$auth.accessToken
          },
          queryStringParameters: {
            fields: ['location_id', 'name'],
            itemsPerPage: false
          }
        }
        this.$Amplify.API.get('locations', '/v1/int/locations', myInit)
          .then((res) => {
            this.allLocations = res.data
            this.loading = false
          })
          .catch((e) => {
            this.loading = false
            console.log(e)
            EventBus.$emit('displaySnackbar', {
              display: true,
              text: this.$t('deliveryMethod.anErrorOccurredLoadingLocation'),
              color: 'error'
            })
          })
      },
    }
  }
</script>

